export default class ReportDto {
    constructor() {
        this.id = '';
        this.project = null;
        this.user = null;
        this.report = '';
        this.title = '';
        this.description = null;
        this.config = {};
        this.dateCreated = '';
        this.dateUpdated = '';
    }
}
//# sourceMappingURL=report-dto.js.map